module.exports = __webpack_public_path__ + "img/icon-24-ic-warning.7c98cf66.svg";